import emojiRegex from 'emoji-regex';

const diameterRegx = /Ø|⌀/g;
export const emojiPattern = new RegExp(`${emojiRegex().source}|${diameterRegx.source}`);
